import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Priorities from "@/components/Priorities";
import Proposals from "@/components/Proposals";
import Gallery from "@/components/Gallery";
import Videos from "@/components/Videos";
import Testimonials from "@/components/Testimonials";
import News from "@/components/News";
import Social from "@/components/Social";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import CookieNotice from "@/components/CookieNotice";
import AdminInbox from "@/components/AdminInbox";
import "@/App.css";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -88 } });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App font-body bg-white text-slate-800 antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Priorities />
        <Proposals />
        <Gallery />
        <Videos />
        <Testimonials />
        <News />
        <Social />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <CookieNotice />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminInbox />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
